export default __webpack_public_path__ + "static/media/tether.7d7f03c4.svg";